import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


const mapPlaceToApiPlaceDto = (values: IEditPlaceForm): IPostEditPlace | {} => {
  let dataMapping: IPostEditPlace | {} = {};

    dataMapping = {
      deleted: values.deleted,
      name: values.name,
      address: values.address,
      area_id: +values.area_id ,
      city_id: +values.city_id,
      zip: values.zip,
      address_num: values.address_num,
      is_emporiki: values.is_emporiki,
      is_citi: values.is_citi,
      description: values.description, 

    }
  
  return dataMapping;
}


const editPlace = ( {data, placeId} : {data: IEditPlaceForm , placeId: number}): Promise<string> => {
  const place = mapPlaceToApiPlaceDto(data);
  return axiosDefaultApi.put(`/api/Places/UpdatePlace/${placeId}`, place);
};

type QueryFnType = typeof editPlace;

type UseEditPlaceOptions = {
  data: IPostEditPlace | {};
  placeId: number;
  config?: MutationConfig<QueryFnType>;
};

export const useEditPlace = ({ config }: UseEditPlaceOptions) => { 
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην επεξεργασία της Τοποθεσίας.`, 500);
            console.error('Couldnt edit Place', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPlaces"])
            addNotification('Η Τοποθεσία Ενημερώθηκε.', 200);
            setIsNotificationVisible(true)
          },
        ...config,
        mutationFn: editPlace,
    })
}